<template>
	<div class="index_banner_sort" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<!-- 轮播图 -->
		<el-card v-for="(item,index) in list" :key="index" style="margin-bottom:10px;">
			<el-row>
				<el-col :span="12">
					<el-form label-width="220px" size="mini">
						<el-form-item label="Select language :">
							<el-select v-model="item.lang" placeholder="" style="width:200px">
								<el-option :label="i.label" :value="i.value" v-for="(i, idx) in langlist" :key="idx"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Upload pics :">
							<!-- <div style="padding-left: 50px;"><label>Upload slideshow pics</label></div> -->
							<div style="color:#777777">Recommend size: 395px * 120px </div>
						</el-form-item>
						<el-form-item>
							<el-upload
								class="avatar-uploader"
								action="#"
								:show-file-list="false"
								:on-change="(file,fileList)=>BannerChange(file,fileList,index)"
								accept="image/*"
								:ref="'banner_sort_'+index"
								:multiple="true"
								v-model="item.pic"
							>
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="10">
					<el-carousel arrow="nerver" height="340px" :autoplay="false" indicator-position="none">
						<el-carousel-item v-for="(i, idx) in item.banner" :key="idx">
							<el-card shadow="never" class="box-card imageperview" :body-style="{ padding: '0px' }">
								<div slot="header" class="clearfix">
									<div class="headtitle">
										<span class="cname" v-if="i.linkvalue != ''">Product set</span>
										<el-button size="mini" type="warning" @click="openselectcargo(index,idx)">Select product</el-button>
										<i class="el-icon-delete" title="删除" @click="delbanner(index,idx)" style="margin-left:20px"></i>
									</div>
								</div>
								<div class="block divimage">
									<el-image :src="i.src">
										<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</el-card>
						</el-carousel-item>
						<el-carousel-item v-if="item.banner.length == 0">
							<div class="block divimage"><p>暂无图片</p></div>
						</el-carousel-item>
					</el-carousel>
				</el-col>
			</el-row>
			 <div class="bottom clearfix" style="text-align:left;padding-left:35px">
				  <el-button type="primary" class="button" size="mini" @click="addlayout(index)">新增设置</el-button>
				  <el-button type="warning" class="button" size="mini" @click="removelayout(index)">移除</el-button>
			</div>
		</el-card>
		<el-row class="footerhandler" v-if="isshow">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savebanner">Save</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">Cancel</div></el-col>
		</el-row>
		<!-- <selectcargo ref="selectcargo" @addcargorow="surecargo" @closecargo="closecargo"></selectcargo> -->
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
//import selectcargo from '@/components/baseinfo/selectcargo';
import dialogwin from '@/components/tools/dialogwin.vue';
export default {
	components: {
		//selectcargo
		dialogwin
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 150,
			showcargolistwin: false,
			cargoparam: {},
			isshow: true,
			divclass: 'index_banner_sort',
			list:[
				{
					banner: [],
					pic:[],
					lang:''
				}
			],
			langlist:[],
			currentlistindex:-1,
			currentindex:-1,
			cargotype:''
		};
	},
	mounted() {
		var that = this;
		if(this.urlparam.l_tablename!=undefined)
			this.cargotype=this.urlparam.l_tablename;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/shop/shopindex.scss');
			that.getindexcargo();
		});
	},
	methods: {
		getindexcargo() {
			var that = this;
			this.isshow = false;
			this.$tool.loading('正在加载', this.divclass);
			//debugger
			this.$apipost.get.GetIndexcargo({ type: 'banner_sort',cargotype:this.cargotype}).then(res => {
				that.isshow = true;
				this.$tool.loadingclose();
				if (res.state == '1') {
					that.list = res.list;
				}
				this.GetLanglist();
			});
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			});
		},
		//本地预览图片
		getLocalImg(file,index) {
			// 获取上传图片的本地url，用于上传前的本地预览
			//debugger
			var postfix = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
			var that = this;
			let reader = new FileReader();
			reader.readAsDataURL(file.raw);
			reader.onload = () => {
				var list = that.list[index].banner.filter(function(b) {
					return b.name == file.name;
				});
				if (list.length == 0) that.list[index].banner.push({ name: file.name, src: reader.result, postfix: postfix, linkvalue: '' });
			};
		},
		addlayout(){
			this.list.push({
					banner: [],
					pic:[],
					lang:''
				});
		},
		removelayout(index){
			this.list.splice(index, 1);
			this.$refs["banner_sort_"+index][0].clearFiles();
			if(this.list.length==0)
				this.addlayout();	
		},
		//上传轮播图
		BannerChange(file, fileList,index) {
			var that = this;
			if (fileList.length > 0) {
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 1;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过1M,不允许上传', 0);
						this.$refs['banner_sort_'+index].abort(e);
					} else {
						var list = that.list[index].pic.filter(function(b) {
							return b.name == e.name;
						});
						if (list.length == 0) {
							that.list[index].pic.push(e);
						}
					}
				});
				that.getLocalImg(file,index);
			}
		},
		//删除轮播图
		delbanner(index,idx) {
			//debugger;
			if (this.list[index] != undefined) {
				this.$refs['banner_sort_'+index][0].abort(this.list[index].pic[idx]);
				this.list[index].pic.splice(idx, 1);
				this.list[index].banner.splice(idx,1);
			}
		},
		// selectcargo(index,idx) {
		// 	var that = this;
		// 	that.currentindex = idx;//每个轮播图中的索引,比如中文轮播图传了三张图片，选择其中一张轮播图进行设置商品
		// 	that.currentlistindex=index;//每种轮播图索引，比如中文轮播图，英文轮播图
		// 	that.cargoparam = {
		// 		type: 'select',
		// 		selectsingle: false,
		// 		searchparam: '',
		// 		cargotype:this.cargotype
		// 	};
		// 	this.$nextTick(function(){
		// 		that.$refs.selectcargo.init(that.cargoparam);
		// 	});
		// 	//if (that.$refs.selectcargo != undefined) that.$refs.selectcargo.init(that.cargoparam);
		// },
		// //确认选择
		// surecargo(e) {
		// 	//debugger;
		// 	var pkcno='';
		// 	e.rows.forEach(b=>{
		// 		pkcno+=b.pkcno+',';
		// 	});
		// 	if(pkcno!='')
		// 		pkcno=pkcno.substring(0,pkcno.length-1);
		// 	//debugger
		// 	this.list[this.currentlistindex].banner[this.currentindex].linkvalue = pkcno;
		// 	//this.$refs.selectcargo.showcargo = false;
		// },
		closecargo() {
			//this.$refs.selcargo.showcargo = false;
		},
		savebanner() {
			var that = this;
			if (this.list.length == 0) {
				this.$tool.message('Please set banner', 0);
				return false;
			} else {
				this.list.forEach(e=>{
					if(e.banner.length==0)
					{
						this.$tool.message('Please set banner', 0);
						return false;
					}else{
						var isset = true;
						e.banner.forEach(e => {
							if (e.linkvalue == '') {
								isset = false;
								return false;
							}
						});
						if (!isset) {
							this.$tool.message('Please select a product for the picture', 0);
							return false;
						}
						if(isset){
							e.banner.forEach(e => {
								if (e.lang == '') {
									isset = false;
									return false;
								}
							});
						}
						if (!isset) {
							this.$tool.message('Please select language', 0);
							return false;
						}
					}
				});
			}
			this.list.forEach(e=>{
				e.linktype='cargo'
			})
			that.isshow = false;
			//debugger
			var paraminfo = {
				list:this.list,
				type: 'banner_sort',
				cargotype:this.cargotype
			};
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.SaveIndexCargo({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					setTimeout(function() {
						that.cancel();
					}, 1000);
				} else {
					that.isshow = true;
					this.$tool.message(res.message, 0);
				}
			});
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		openselectcargo(index,idx){
			var that=this;
			that.currentindex = idx;//每个轮播图中的索引,比如中文轮播图传了三张图片，选择其中一张轮播图进行设置商品
			that.currentlistindex=index;//每种轮播图索引，比如中文轮播图，英文轮播图
			this.$apipost.get.GetLinkInfo({ l_id:576 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:'选择商品'});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		dialogsrue(e){
			//debugger
				//读取商品
			if(e.l_id==576){
				if(e.rows!=undefined)
				{
					var pkcno='';
					e.rows.forEach(b=>{
						pkcno+=b.pkcno+',';
					});
					if(pkcno!='')
						pkcno=pkcno.substring(0,pkcno.length-1);
					this.list[this.currentlistindex].banner[this.currentindex].linkvalue = pkcno;
				}
			}
		}
	}
};
</script>

<style></style>
